import { useState } from 'react';
import useFetch from '../../../hooks/useFetch';
import { buildEndpoint } from '../EndPoints';
import { ServiceEvents } from '../shared/interfaces';

/**
 * Hook para el servicio de análisis de factibilidad de marcas con IA
 */
const useBrandFeasibilityService = () => {
    const { doPost } = useFetch();
    
    const [fetchingEvaluateFeasibility, setFetchingEvaluateFeasibility] = useState(false);
    
    const BASE_PATH = 'brand-registrations/inapi';
    
    /**
     * Evalúa la factibilidad de registrar una marca usando IA + scraper INAPI
     * @param brandName - Nombre de la marca a evaluar
     * @param brandDescription - Descripción de la marca
     * @param classes - Array de clases de Niza (opcional)
     * @param events - Callbacks de éxito/error
     */
    const evaluateFeasibility = (
        brandName: string,
        brandDescription: string,
        classes: string[],
        events: ServiceEvents = {}
    ) => {
        const data = {
            brand_name: brandName,
            brand_description: brandDescription,
            classes: classes
        };
        
        doPost({
            ...events,
            url: buildEndpoint(`${BASE_PATH}/evaluate-feasibility`),
            body: data,
            setFetching: setFetchingEvaluateFeasibility
        });
    };
    
    return {
        evaluateFeasibility,
        fetchingEvaluateFeasibility
    };
};

export default useBrandFeasibilityService;

